import { BetsCycleLoader } from '@/components/ui/betscycle-loader'

export function SearchLoadingState() {
	return (
		<div className='flex min-h-[160px] flex-col items-center justify-center gap-3 py-8'>
			<BetsCycleLoader size={32} />
			<p className='text-sm text-muted-foreground'>Searching games…</p>
		</div>
	)
}
